import React, {useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {useAppDispatch} from "../../utils/Hooks";
import {LoggedInView} from "../common/LoggedInView";
import {apiClient} from "../../utils/ApiClient";
import CategoryType from "../../models/CategoryType";
import {VendorContact} from "../../models/VendorContact";

interface LoadingsScreenProps {}

export const LoadingsScreen: React.FC<LoadingsScreenProps> = () => {

    const {id} = useParams();

    const [loadings, setLoadings] = useState<any[]>([]);

    useEffect(() => {

        const fetchData = async () => {

            try {
                const response = await apiClient.get(`clients/${id}/loadings`);
                const data = response.data;
                setLoadings(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        if ( !!id ) {
            fetchData();
        }

    }, [id]);

    return (
        <LoggedInView fullWidth={false}>
            <h2>Laadimised</h2>
            {loadings.length > 0 &&
            <table className="data">
              <thead>
              <tr>
                <th>
                  Ettevõte
                </th>
                <th>
                  Kontakt
                </th>
                <th>
                  Kontakti e-mail
                </th>
                <th>
                  Staatus
                </th>
                <th>
                </th>
              </tr>
              </thead>
              <tbody>
              {loadings.map(contact => (
                  <tr>
                      <td>{contact?.company}</td>
                      <td>{contact?.name}</td>
                      <td>{contact?.email}</td>
                      <td>Aktiivne</td>
                      <td className="right">
                          <Link to={`/clients/${id}/loadings/${contact.id}/modify`}>Muuda</Link>
                          <span> | </span>
                          <Link to={`/clients/${id}/loadings/${contact.id}/delete`}>Eemalda soovitustest</Link>
                      </td>
                  </tr>
              ))}
              </tbody>
            </table>
            }
        </LoggedInView>
    )

}